export default __webpack_public_path__ + "2b4c3590f7bec5726e45e10a11e1bdd2.png";